import Axios from "axios";

import { useContext, useState } from "react";

import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";


/**
 * این کامپوننت برای مدال تایید کاراست
 * در جدول سفارشات است
 */
export default function ModalConfrim({ showitem, handleCloseMoudal, id, handeldeleteitem }) {

    const { urldashboard, authentication,urlPatch } = useContext(DashboardContext);


    const [loading, setLoading] = useState(false)

    const handelsubmit = async () => {

        setLoading(true)

        try {

            const res = await Axios.post(`${urldashboard}${urlPatch}/confirm/${id}`, JSON.stringify({}), {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })
            const data = await res.data
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
            handleCloseMoudal()
            handeldeleteitem()
        } catch (error) {
            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLoading(false)
            }
            else {
                setLoading(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    return (
        <Modal show={showitem} onHide={handleCloseMoudal}>
            <Modal.Header>
            <Modal.Title>تایید کار</Modal.Title>
            <i className="fa fa-times mr-auto" style={{fontSize:'16px',cursor:'pointer'}} onClick={handleCloseMoudal}  aria-hidden="true"></i>


            </Modal.Header>
            <Modal.Body>
                آیا از تایید این کار مطمئن هستید؟
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={loading} onClick={handleCloseMoudal}>
                    لغو
          </Button>
                <Button variant="success" disabled={loading} onClick={handelsubmit}>
                    {
                        loading ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "ثبت"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
